import { SearchableDropdown } from './SearchableDropdown';

interface AttractionCategoryDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function AttractionCategoryDropdown({
  value,
  onChange,
  placeholder = 'Select Category',
  className,
}: AttractionCategoryDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search categories..."
      className={className}
      endpoint="attraction-categories"
      emptyText="No categories found."
    />
  );
}
